//TODO : Ajouter chargements quand téléchargement du zip
<template>
  <div class="card shadow"
       :class="type === 'dark' ? 'bg-default': ''">
    <div class="card-header border-0"
         :class="type === 'dark' ? 'bg-transparent': ''">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0" :class="type === 'dark' ? 'text-white': ''">
            {{title}}
          </h3>
        </div>
      </div>
    </div>
    <div class="table-responsive">
        <div class="col-lg-3 float-left">
          <base-input label="Date de début" input-classes="form-control-alternative" :required="required">
            <flat-picker slot-scope="{focus, blur}"
                        @on-open="focus"
                        @on-close="blur"
                        @blur="newDate"
                        :config="{allowInput: true, dateFormat: 'Y-m-d',}"
                        placeholder="Date de début"
                        class="form-control form-control-alternative datepicker"
                        v-model="datefrom"/>
          </base-input>
          <base-button v-on:click="newDate" type="success col-lg-12 mb-2">Recharger les données</base-button>
        </div>
        <div class="col-lg-3 float-left">
          <base-input label="Date de fin" input-classes="form-control-alternative" :required="required">
            <flat-picker slot-scope="{focus, blur}"
                        @on-open="focus"
                        @on-close="blur"
                        @blur="newDate"
                        :config="{allowInput: true, dateFormat: 'Y-m-d',}"
                        placeholder="Date de fin"
                        class="form-control form-control-alternative datepicker"
                        v-model="dateto"/>
          </base-input>
        </div>
        <div class="col-lg-3 float-left">
          Télécharger :
          <base-button v-on:click="dlPayee" type="success col-lg-12 mb-2">Factures payées</base-button>
          <base-button v-on:click="dlNonPayee" type="success col-lg-12 mb-3">Factures à payer</base-button>
        </div>
        <div class="col-lg-3 float-right">
          <base-input alternative=""
                      placeholder="Rechercher"
                      label="Recherche"
                      input-classes="form-control-alternative input_search"
                      v-model="search"
                      @change="searchData"
          /> 
        </div>
      
      
      <base-table class="table align-items-center table-flush"
                  :class="type === 'dark' ? 'table-dark': ''"
                  :thead-classes="type === 'dark' ? 'thead-dark': 'thead-light'"
                  tbody-classes="list"
                  :data="data"
                  :columns="columns"
                  :sortKey.sync="sortKey"
                  :reverse.sync="reverse"
                  @KeyChanged="reloadDataSorted"
                  @reverse="reverseChange"
                  @sortKey="sortKeyChange">
        <template slot="columns">
        </template>

        <template slot-scope="{row}">
          <td>
            {{row.idFournisseur}}
          </td>
          <td>
            {{row.nom}}
          </td>
          <td>
            {{row.montantapayer}}
          </td>
          <td>
            {{row.montantpaye}}
          </td>
          <td>
            {{row.datemaxreglement}}
          </td>
        </template>

      </base-table>
    </div>

    <div class="card-footer d-flex justify-content-end"
         :class="type === 'dark' ? 'bg-transparent': ''">
        <base-pagination 
            :total="total"
            :perPage="perPage"
            @input="changeData"
            ></base-pagination>
    </div>

  </div>
</template>
<script>
  import Vue from 'vue';
  import constvar from '@/const'
  import _ from 'lodash'
  import router from '@/router'
  import flatPicker from "vue-flatpickr-component";
  import "flatpickr/dist/flatpickr.css";
  import jszip from "jszip"
  import filesaver from "file-saver"
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.css';
  
  Vue.use(Loading);

  async function asyncForEach(array, callback) {
    for (let index = 0; index < array.length; index++) {
      await callback(array[index], index, array);
    }
  }


  export default {
    name: 'fournisseur-table',
    components: { 
        flatPicker,
    },
    props: {
      type: {
        type: String
      },
      title: String,
    },
    data() {
      return { 
        total: 0,
        alldata: [],
        data: [],
        perPage: 10,
        value: 1,
        sortKey: 'montantapayer',
        reverse: true,
        search: '',
        datefrom: null,
        dateto: null,
        required: true,
        columns: [
          ['idFournisseur','ID'],
          ['nom','Nom'],
          ['montantapayer','Montant à payer'],
          ['montantpaye','Montant payé'],
          ['datemaxreglement','Délai avant réglement max'],
          ['','']
        ],
        allfournisseurs: {
            'idFournisseur':0,
            'nom':'Tous fournisseurs confondus',
            'montantapayer':0,
            'montantpaye':0,
            'datemaxreglement':0  
        }
      }
    },
    computed: {
      alldata_filtered: function() { 
        if(this.search != '') {
          return this.alldata.filter(({idFournisseur, nom}) => idFournisseur == this.search || nom.toLowerCase().includes(this.search.toLowerCase()));
        } else {
          return this.alldata;
        }
      }
    },
    async created() {
      var date = new Date();
      this.datefrom = new Date(date.getFullYear(), date.getMonth(), 1);
      this.dateto = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      
      const response = await fetch(constvar.api_url+'facture', {
      method: 'GET',
      credentials: 'include',
      });
      if(response.ok) { 
          let self = this;
          const factures = await response.json();
          if(factures.code != 409) {
              let fournisseurs = []
              factures.forEach(function (facture) {
                  let datefrom = new Date(self.datefrom)
                  let dateto = new Date(self.dateto)

                  let datefacture = new Date(facture.date)

                  if(datefacture >= datefrom && datefacture <= dateto) {
                    let index = _.findIndex(fournisseurs, [ 'idFournisseur', facture.idFournisseur ]) 

                    if(index == -1) {
                        //Le fournisseur n'existe pas encore dans l'array
                        if(facture.idEtatPaiement == 1) {
                            fournisseurs.push(
                                {
                                    'idFournisseur':facture.idFournisseur,
                                    'nom':facture.fournisseur_nom,
                                    'montantapayer':0,
                                    'montantpaye':Number(facture.montantHT),
                                    'datemaxreglement':0                                
                                }
                            )
                            self.allfournisseurs.montantpaye += Number(facture.montantHT)
                        } else {
                            fournisseurs.push(
                                {
                                    'idFournisseur':facture.idFournisseur,
                                    'nom':facture.fournisseur_nom,
                                    'montantapayer':facture.montantHT,
                                    'montantpaye':0,
                                    'datemaxreglement':facture.dateReglementMax                             
                                }
                            )
                            self.allfournisseurs.montantapayer += Number(facture.montantHT)
                            self.allfournisseurs.datemaxreglement = facture.dateReglementMax  
                        }
                    } else {
                        //Le fournisseur existe dans l'array
                        if(facture.idEtatPaiement == 1) {
                            fournisseurs[index].montantpaye += Number(facture.montantHT)
                            self.allfournisseurs.montantpaye += Number(facture.montantHT)
                        } else {
                            if(fournisseurs[index].datemaxreglement == 0) {
                                fournisseurs[index].datemaxreglement = facture.dateReglementMax
                            }
                            var last_date = new Date(fournisseurs[index].datemaxreglement)
                            var new_date = new Date(facture.dateReglementMax)
                            if(new_date<last_date) {
                                fournisseurs[index].datemaxreglement = facture.dateReglementMax
                            }
                            fournisseurs[index].montantapayer += Number(facture.montantHT)
                            self.allfournisseurs.montantapayer += Number(facture.montantHT)
                        }
                    }
                  }
                  
              })

              fournisseurs.forEach(function (fournisseur) {
                  if(fournisseur.datemaxreglement == 0) {
                      fournisseur.datemaxreglement = "Pas de commande à payer"
                  }

                  var last_date = new Date(self.allfournisseurs.datemaxreglement)
                  var new_date = new Date(fournisseur.datemaxreglement)
                  if(new_date<last_date || self.allfournisseurs.datemaxreglement == 0) {
                      self.allfournisseurs.datemaxreglement = fournisseur.datemaxreglement
                  }
              })

              this.allfournisseurs.montantapayer = this.allfournisseurs.montantapayer.toString();
              this.allfournisseurs.montantpaye = this.allfournisseurs.montantpaye.toString();

              this.$emit('allfournisseurschange', this.allfournisseurs)

              this.alldata = fournisseurs;
              this.changeData(1);
              this.total = this.alldata_filtered.length;
          } else { 
              router.push("login")    
          }
      }
    },
    methods: {
        sortTableData: function() {
            this.alldata.forEach(function(element) {
                element.idFournisseur = Number(element.idFournisseur);
                element.montantHT = Number(element.montantHT);
                element.montantTTC = Number(element.montantTTC);
            })
            return _.orderBy(this.alldata_filtered, this.sortKey, (this.reverse) ? 'desc' : 'asc')
        },
        changeData: function(e) {
            let page = e;
            let perPage = this.perPage;
            let from = (page * perPage) - perPage;
            let to = (page * perPage);
            let tableData = this.sortTableData();
            this.data = tableData.slice(from, to);
            this.value = page;
        },
        reloadDataSorted: function() {
          this.changeData(this.value);
        },
        sortKeyChange: function(e) {
          this.sortKey = e;
        },
        reverseChange: function(e) {
          this.reverse = e;
        },
        searchData: function() {
        },
        reloadData: async function() {
            const response = await fetch(constvar.api_url+'fournisseur', {
            method: 'GET',
            credentials: 'include',
            });
            if(response.ok) { 
                const json = await response.json();
                //check if api return regenerated token
                if(json.code != 409) {
                    this.alldata = json;
                    this.changeData(1)
                    this.total = this.data.length;
                } else { 
                    router.push("login")    
                }
            } 
        },
        dlPayee: async function() {
          const response = await fetch(constvar.api_url+'facture', {
          method: 'GET',
          credentials: 'include',
          });
          if(response.ok) { 
            let loader = this.$loading.show({
              // Optional parameters
              container: null,
              canCancel: false,
            });
            let self = this;
            var zip = new jszip();
            const factures = await response.json();
            if(factures.code != 409) {
              const start = async () => {
                await asyncForEach(factures, async (facture) => {
                  let datefrom = new Date(self.datefrom)
                  let dateto = new Date(self.dateto)

                  let datefacture = new Date(facture.date)

                  if(datefacture >= datefrom && datefacture <= dateto && facture.idEtatPaiement == 1) { 
                    const responsefile = await fetch(constvar.api_url+'facture/'+facture.idFacture, {
                      method: 'GET',
                      credentials: 'include',
                    });
                    if(responsefile.ok) {
                      const facturefile = await responsefile.json(); 
                      zip.file(facturefile.nameFile, facturefile.contentFile, {base64:true});
                    }
                  }
                })
                zip.generateAsync({type:"blob"})
                .then(function(content) {
                  filesaver.saveAs(content, "factures.zip")
                  loader.hide()
                })
              }
              start();
            }
          }
        },
        dlNonPayee: async function() {
          const response = await fetch(constvar.api_url+'facture', {
          method: 'GET',
          credentials: 'include',
          });
          if(response.ok) { 
            let loader = this.$loading.show({
              // Optional parameters
              container: null,
              canCancel: false,
            });
            let self = this;
            var zip = new jszip();
            const factures = await response.json();
            if(factures.code != 409) {
              const start = async () => {
                await asyncForEach(factures, async (facture) => {
                  let datefrom = new Date(self.datefrom)
                  let dateto = new Date(self.dateto)

                  let datefacture = new Date(facture.date)

                  if(datefacture >= datefrom && datefacture <= dateto && facture.idEtatPaiement != 1) { 
                    const responsefile = await fetch(constvar.api_url+'facture/'+facture.idFacture, {
                      method: 'GET',
                      credentials: 'include',
                    });
                    if(responsefile.ok) {
                      const facturefile = await responsefile.json(); 
                      zip.file(facturefile.nameFile, facturefile.contentFile, {base64:true});
                    }
                  }
                })
                zip.generateAsync({type:"blob"})
                .then(function(content) {
                  filesaver.saveAs(content, "factures.zip")
                  loader.hide()
                })
              }
              start();
            }
          }
        },
        newDate: async function() {
          this.allfournisseurs= {
            'idFournisseur':0,
            'nom':'Tous fournisseurs confondus',
            'montantapayer':0,
            'montantpaye':0,
            'datemaxreglement':0  
          }
          
          const response = await fetch(constvar.api_url+'facture', {
          method: 'GET',
          credentials: 'include',
          });
          if(response.ok) { 
              let self = this;
              const factures = await response.json();
              if(factures.code != 409) {
                  let fournisseurs = []
                  factures.forEach(function (facture) {
                      let datefrom = new Date(self.datefrom)
                      let dateto = new Date(self.dateto)

                      let datefacture = new Date(facture.date)

                      if(datefacture >= datefrom && datefacture <= dateto) {
                        let index = _.findIndex(fournisseurs, [ 'idFournisseur', facture.idFournisseur ]) 

                        if(index == -1) {
                            //Le fournisseur n'existe pas encore dans l'array
                            if(facture.idEtatPaiement == 1) {
                                fournisseurs.push(
                                    {
                                        'idFournisseur':facture.idFournisseur,
                                        'nom':facture.fournisseur_nom,
                                        'montantapayer':0,
                                        'montantpaye':Number(facture.montantHT),
                                        'datemaxreglement':0                                
                                    }
                                )
                                self.allfournisseurs.montantpaye += Number(facture.montantHT)
                            } else {
                                fournisseurs.push(
                                    {
                                        'idFournisseur':facture.idFournisseur,
                                        'nom':facture.fournisseur_nom,
                                        'montantapayer':facture.montantHT,
                                        'montantpaye':0,
                                        'datemaxreglement':facture.dateReglementMax                             
                                    }
                                )
                                self.allfournisseurs.montantapayer += Number(facture.montantHT)
                                self.allfournisseurs.datemaxreglement = facture.dateReglementMax  
                            }
                        } else {
                            //Le fournisseur existe dans l'array
                            if(facture.idEtatPaiement == 1) {
                                fournisseurs[index].montantpaye += Number(facture.montantHT)
                                self.allfournisseurs.montantpaye += Number(facture.montantHT)
                            } else {
                                if(fournisseurs[index].datemaxreglement == 0) {
                                    fournisseurs[index].datemaxreglement = facture.dateReglementMax
                                }
                                var last_date = new Date(fournisseurs[index].datemaxreglement)
                                var new_date = new Date(facture.dateReglementMax)
                                if(new_date<last_date) {
                                    fournisseurs[index].datemaxreglement = facture.dateReglementMax
                                }
                                fournisseurs[index].montantapayer += Number(facture.montantHT)
                                self.allfournisseurs.montantapayer += Number(facture.montantHT)
                            }
                        }
                      }
                      
                  })

                  fournisseurs.forEach(function (fournisseur) {
                      if(fournisseur.datemaxreglement == 0) {
                          fournisseur.datemaxreglement = "Pas de commande à payer"
                      }

                      var last_date = new Date(self.allfournisseurs.datemaxreglement)
                      var new_date = new Date(fournisseur.datemaxreglement)
                      if(new_date<last_date || self.allfournisseurs.datemaxreglement == 0) {
                          self.allfournisseurs.datemaxreglement = fournisseur.datemaxreglement
                      }
                  })

                  this.allfournisseurs.montantapayer = this.allfournisseurs.montantapayer.toString();
                  this.allfournisseurs.montantpaye = this.allfournisseurs.montantpaye.toString();
  
                  this.$emit('allfournisseurschange', this.allfournisseurs)

                  this.alldata = fournisseurs;
                  this.changeData(1);
                  this.total = this.alldata_filtered.length;
              } else { 
                  router.push("login")    
              }
          }
        }
    },
    watch: {
      alldata_filtered: function() {
        this.changeData(this.value);
      },
    },
  }
</script>
<style>
</style>
